import React from 'react';
import {
    Select,
    MenuItem,
    SelectChangeEvent,
    Box,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSelect = styled(Select)(({ theme }) => ({
    color: theme.daPalette.grey.contrastText,
    backgroundColor: theme.daPalette.grey.light,
    height: '32px',
    minWidth: 160,
    '&:hover': {
        backgroundColor: theme.daPalette.grey.main,
    },
    '&.Mui-focused': {
        backgroundColor: '#ffffff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiSelect-select': {
        paddingTop: '6px',
        paddingBottom: '6px',
    },
}));

export interface FilterOption<T = string> {
    value: T;
    label: string;
}

export interface FilterDropdownProps<T = string> {
    label?: string;
    options: FilterOption<T>[];
    selectedValues: T[];
    onChange: (selectedValues: T[]) => void;
    disabled?: boolean;
}

export function FilterDropdown<T extends string = string>({
    label = 'Filter',
    options,
    selectedValues,
    onChange,
    disabled = false,
}: FilterDropdownProps<T>): JSX.Element {

    const handleChange = (event: SelectChangeEvent<unknown>) => {
        const value = event.target.value as string;
        onChange(value ? [value as T] : []);
    };

    const selectedValue = selectedValues.length > 0 ? selectedValues[0] : '';

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', marginRight: '5px' }}>
            <Typography
                variant="body2"
                sx={{
                    mr: 0.5,
                    color: (theme) => theme.daPalette.grey.contrastText,
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                }}
            >
                {label}:
            </Typography>
            <StyledSelect
                id={`${label}-filter`}
                value={selectedValue}
                onChange={handleChange}
                displayEmpty
                disabled={disabled}
            >
                <MenuItem value="">All</MenuItem>
                {options.map((option) => (
                    <MenuItem key={String(option.value)} value={String(option.value)}>
                        {option.label}
                    </MenuItem>
                ))}
            </StyledSelect>
        </Box>
    );
}
